import { CONTACT, IMAGES } from "../../data";
import { Phone, ArrowRight } from "lucide-react";
import { openInquiry } from "../../lib/inquiry";
import { Reveal } from "./Reveal";

export const FinalCTA = () => (
  <section className="relative bg-oyf-black text-white overflow-hidden py-20 md:py-28" data-testid="final-cta">
    <div className="pointer-events-none absolute inset-0 flex items-center justify-end opacity-[0.08]">
      <img src={IMAGES.map} alt="" aria-hidden="true" className="h-[110%] w-auto translate-x-1/4" />
    </div>
    <div className="container-oyf relative z-10">
      <Reveal>
        <div className="max-w-2xl">
          <span className="inline-block bg-oyf-yellow text-oyf-black text-xs font-bold tracking-widest uppercase px-3 py-1.5 rounded mb-6">Get Moving</span>
          <h2 className="font-display font-extrabold tracking-tight text-4xl md:text-6xl leading-[0.98]">
            Have Freight That Needs to Move?
          </h2>
          <p className="mt-5 text-white/70 text-base md:text-lg leading-relaxed">
            Send us the route, dimensions, weight and deadline. We&apos;ll review the shipment requirements and contact you about available transportation options.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <button onClick={() => openInquiry("Final CTA")} className="inline-flex items-center justify-center gap-2 bg-oyf-yellow text-oyf-black font-bold px-7 py-4 rounded-md hover:-translate-y-0.5 hover:shadow-[5px_5px_0_0_#F4C400] transition-transform duration-200" data-testid="finalcta-quote">
              Send Inquiry <ArrowRight size={18} />
            </button>
            <a href={CONTACT.tel} className="inline-flex items-center justify-center gap-2 border-2 border-white/30 text-white font-bold px-7 py-4 rounded-md hover:border-oyf-yellow hover:text-oyf-yellow transition-colors duration-200" data-testid="finalcta-call">
              <Phone size={17} /> Call {CONTACT.phone}
            </a>
          </div>
          <p className="mt-5 text-sm text-white/45">Canada and United States transportation inquiries</p>
        </div>
      </Reveal>
    </div>
  </section>
);
